'use strict';

function getAlert(opts) {

  var type = opts.type || 'info';
  var className = {
    'alert': true
  };
  className['alert-' + type] = true;

  return {
    tag: 'div',
    attrs: {
      className: className
    },
    children: opts.children
  };
}

module.exports = getAlert;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getAlert.js
 ** module id = 1061
 ** module chunks = 0
 **/